import initialiseAdobeAnalytics from "./adobe";
import initialiseOptimizelyTracking from "./optimizely";

const initialiseAnalytics = () => {
  initialiseAdobeAnalytics();
  initialiseOptimizelyTracking();
};

export default initialiseAnalytics;
